export default {
  isConflictError(error) {
    return error.response && error.response.status == 409;
  },
  getConflictErrorMessage(error) {
    if (
      error.response &&
      error.response.data &&
      error.response.data.detail &&
      error.response.data.detail[0] &&
      error.response.data.detail[0].msg
    ) {
      return error.response.data.detail[0].msg;
    }
    return null;
  }
};
